import React from 'react';

import { useAppSelector } from 'state/hooks';
import {
  selectCurrentProjectInfo,
  selectShortestAvailableBin,
  selectTimeOfDay,
  selectTimelineMetric,
} from 'state/workflowSlice';

import { minutes_to_slots } from 'features/common/slotsUtils';
import {
  formatIncidentInfoToTableRows,
  formatSegmentInfoToTableRows,
} from 'features/workflow_timeline/timelineTooltipContents';

import { Segment } from '../../appTypes';
import { SegmentNameAndDirectionalityInfo } from '../map/tooltips/MapSegmentTooltip';

import styles from '../map/Map.module.css';

export type TimelineTooltipData = {
  segment?: Segment;
  incident?: any;
};

export function TimelineMapSegmentTooltip({
  data,
}: {
  data: TimelineTooltipData;
}) {
  const timeOfDay = useAppSelector(selectTimeOfDay);
  const userProject = useAppSelector(selectCurrentProjectInfo);
  const binSize = useAppSelector(selectShortestAvailableBin);
  const timeOfDayOffset = minutes_to_slots(timeOfDay, binSize || 15);
  const timelineMetric = useAppSelector(selectTimelineMetric);
  const segment = data?.segment;
  const incident = data?.incident;
  const chunks = [];
  if (segment) {
    chunks.push(
      <React.Fragment key="segment-info">
        <tr key="segment-header">
          <td colSpan={2}>
            <SegmentNameAndDirectionalityInfo
              cardinal={segment.properties.cdld}
              hwc={segment.properties.hwc}
              name={segment.properties.name}
            />
          </td>
        </tr>
        {formatSegmentInfoToTableRows(
          segment,
          userProject.uses_metric,
          timeOfDay,
          timeOfDayOffset,
          timelineMetric,
        )}
      </React.Fragment>,
    );
  }
  if (incident) {
    chunks.push(formatIncidentInfoToTableRows(incident));
  }

  if (chunks.length > 0) {
    return (
      <div className={styles.map_tooltip_container} data-hide-in-export>
        <table>
          <tbody>{chunks}</tbody>
        </table>
      </div>
    );
  }
  return null;
}
